var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contact)?_c('div',[(_vm.contact.email)?_c('a',{attrs:{"href":'mailto:' + _vm.contact.email,"target":"_blank"}},[_c('v-icon',[_vm._v("mdi-email")]),_vm._v(" "+_vm._s(_vm.contact.name)+" ")],1):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }